import { __exports as PresentationTokenFactory } from './_virtual-PresentationTokenFactory.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireLogger } from './vp-js-token-engine-build-infrastructure-logger.js';
import { __require as requireTokenGeneratorInstance } from './vp-js-token-engine-build-tokenGenerators-infrastructure-tokenGeneratorInstance.js';

var hasRequiredPresentationTokenFactory;

function requirePresentationTokenFactory () {
	if (hasRequiredPresentationTokenFactory) return PresentationTokenFactory;
	hasRequiredPresentationTokenFactory = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(PresentationTokenFactory, "__esModule", {
	  value: true
	});
	PresentationTokenFactory.default = void 0;
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var _logger = requireLogger();
	var _tokenGeneratorInstance = requireTokenGeneratorInstance();
	let PresentationTokenFactory$1 = class PresentationTokenFactory {
	  constructor() {
	    (0, _defineProperty2.default)(this, "tokenGeneratorMap", void 0);
	    this.tokenGeneratorMap = _tokenGeneratorInstance.tokenGeneratorMapInstance;
	  }
	  generateToken(presentationInfo, presentationType) {
	    if (!presentationInfo || Object.keys(presentationInfo).length === 0 || !presentationType) {
	      _logger.logger.warn("Can't generate token", {
	        contextData: {
	          presentationType,
	          presentationInfo
	        }
	      });
	      return '';
	    }
	    try {
	      const tokenGenerator = this.tokenGeneratorMap.get(presentationType);
	      if (tokenGenerator) {
	        const validationErrors = tokenGenerator.getValidationErrors(presentationInfo);
	        if (validationErrors) {
	          throw new Error("There are validation errors for ".concat(presentationType, ": ").concat(validationErrors));
	        }
	        return tokenGenerator.generateToken(presentationInfo, presentationType);
	      }
	      throw new Error("Invalid presentationType: ".concat(presentationType));
	    } catch (error) {
	      _logger.logger.error(error, {
	        contextData: {
	          presentationType,
	          presentationInfo
	        }
	      });
	      throw new Error(error);
	    }
	  }
	};
	PresentationTokenFactory.default = PresentationTokenFactory$1;
	
	return PresentationTokenFactory;
}

export { requirePresentationTokenFactory as __require };
//# sourceMappingURL=vp-js-token-engine-build-tokenGenerators-PresentationTokenFactory.js.map
